import { Storage, StorageGetConfig } from '@aws-amplify/storage';
import { useMeta } from 'hooks';
import { useAsync } from 'react-async-hook';

export const useS3Document = (
  key: string | undefined,
  config?: { skip?: boolean } & StorageGetConfig<Record<string, unknown>>
) => {
  const { result, ...asyncMeta } = useAsync(async () => {
    const object =
      key && config?.skip !== true
        ? await Storage.get(key, {
            bucket: process.env.REACT_APP_DOCUMENT_BUCKET,
            ...config,
          })
        : null;

    return object?.toString();
  }, [key, config]);

  const { loading } = useMeta({ ...asyncMeta, error: asyncMeta.error?.message });

  return {
    result,
    loading,
  };
};
